





































































import DictMixin from '@/mixins/dict-mixin';
import { IndicatorDto } from '@/services/indicator';
import { mixins } from 'vue-class-component';
import { Component, PropSync, Prop, Watch } from 'vue-property-decorator';

@Component
export default class SubjectForm1 extends mixins(DictMixin) {
  @PropSync('formData') syncFormData!: IndicatorDto;
  @Prop() id!: any;

  @Watch('syncFormData', { deep: true })
  onBaseChange() {
    this.indFirstLevel = this.syncFormData.indFirstLevel || '';
    this.indSecondLevel = this.syncFormData.indSecondLevel || '';
    this.indThirdLevel = this.syncFormData.indThirdLevel || '';
  }

  indFirstLevel: string = '';
  indSecondLevel: string = '';
  indThirdLevel: string = '';

  SUB_SCENE: any[] = [];

  @Watch('indFirstLevel')
  changeIndFirstLevel(e: string) {
    if (!e) return false;
    if (!this.DICT_JOURNEY_SCENE) {
      setTimeout(() => {
        this.changeIndFirstLevel(e);
      }, 100);
      return false;
    }
    this.SUB_SCENE = [];
    if (e) {
      let item = this.DICT_JOURNEY_SCENE.find((v: any) => v.value === e);
      this.SUB_SCENE = this.DICT_JOURNEY_SUB_SCENE.filter((v: any) => v.parentItemCode === item.dictItemCode);
    }
    this.syncFormData.indFirstLevel = e;
  }

  SCENE_STEP: any[] = [];
  @Watch('indSecondLevel')
  changeIndSecondLevel(e: string) {
    if (!e) return false;
    if (this.SUB_SCENE.length === 0) {
      setTimeout(() => {
        this.changeIndSecondLevel(e);
      }, 100);
      return false;
    }
    this.SCENE_STEP = [];
    if (e) {
      let item = this.SUB_SCENE.find((v: any) => v.value === e);
      this.SCENE_STEP = this.DICT_JOURNEY_SCENE_STEP.filter((v: any) => v.parentItemCode === item.dictItemCode);
    }
    this.syncFormData.indSecondLevel = e;
  }

  @Watch('indThirdLevel')
  changeIndThirdLevel(e: string) {
    if (!e) return false;
    this.syncFormData.indThirdLevel = e;
  }
}
